(function () {
  'use strict';

  angular
    .module('fertilization.phDemandExports')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('fertilization.phDemandExports', {
        abstract: true,
        url: '/ph-demand-exports',
        template: '<ui-view />'
      });
  }
}());
